import { useTranslation } from 'react-i18next';
import { usePortfolio } from '../../hooks/usePortfolio';

interface ExperienceItem {
  company: string;
  role: string;
  period: string;
  description: string;
  description_en: string;
  order: number;
}

export function Experience() {
  const { t, i18n } = useTranslation();
  const { data, loading } = usePortfolio<ExperienceItem>('EXPERIENCE');
  const isEn = i18n.language === 'en';

  return (
    <section id="experience" className="py-24 px-6">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-mono text-sm text-accent">{`// ${t('nav.experience')}`}</h2>
        <p className="mt-6 max-w-3xl text-text-muted leading-relaxed">
          {isEn
            ? 'The best software teams don\'t just have great engineers — they have the right conditions to do great work. Over 7+ years in DevOps, Cloud, and Platform Engineering, I\'ve worked as a Lead Solution Architect, built internal platforms, and led cloud architecture across enterprise environments. Today, my focus is on accompanying engineering organizations in their journey toward an AI-first model — prompt engineering, context featuring, and AI-assisted workflows embedded into the daily development cycle.'
            : 'Los mejores equipos de software no solo tienen grandes ingenieros — tienen las condiciones correctas para hacer gran trabajo. Con más de 7 años en DevOps, Cloud y Platform Engineering, trabajé como Lead Solution Architect, construí plataformas internas y lideré arquitectura cloud en entornos enterprise. Hoy mi foco está en acompañar organizaciones de ingeniería en su camino hacia un modelo AI-first — prompt engineering, context featuring y workflows asistidos por IA integrados en el ciclo de desarrollo diario.'}
        </p>
        <div className="mt-12 space-y-8">
          {loading ? (
            <div className="animate-pulse space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-24 rounded border border-border bg-bg-surface" />
              ))}
            </div>
          ) : (
            data
              .sort((a, b) => a.order - b.order)
              .map((item, idx) => (
                <div key={idx} className="border-l-2 border-border pl-6 transition-colors hover:border-accent">
                  <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between">
                    <h3 className="text-lg font-semibold">{item.company}</h3>
                    <span className="font-mono text-xs text-text-muted">{item.period}</span>
                  </div>
                  <p className="mt-1 font-mono text-sm text-accent">{item.role}</p>
                  <p className="mt-2 text-sm text-text-muted leading-relaxed">
                    {isEn ? item.description_en : item.description}
                  </p>
                </div>
              ))
          )}
        </div>
      </div>
    </section>
  );
}
